/**
 * Lightweight device fingerprint captured once per page load and sent with
 * every UsageLog ingest call (open / ping / complete / beacon).
 */
export interface DeviceInfo {
  deviceType: 'Mobile' | 'Tablet' | 'Desktop';
  os: string;
  browser: string;
  userAgent: string;
}

let cached: DeviceInfo | null = null;

export function getDeviceInfo(): DeviceInfo {
  if (cached) return cached;
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  cached = {
    deviceType: detectDeviceType(ua),
    os: detectOs(ua),
    browser: detectBrowser(ua),
    userAgent: ua,
  };
  return cached;
}

function detectDeviceType(ua: string): DeviceInfo['deviceType'] {
  const lower = ua.toLowerCase();
  if (/tablet|ipad|playbook|silk/.test(lower)) return 'Tablet';
  if (/android|iphone|ipod|mobile|opera mini|webos|blackberry/.test(lower)) return 'Mobile';
  return 'Desktop';
}

function detectOs(ua: string): string {
  if (/windows/i.test(ua)) return 'Windows';
  if (/android/i.test(ua)) return 'Android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
  if (/mac os x/i.test(ua)) return 'macOS';
  if (/linux/i.test(ua)) return 'Linux';
  return 'Unknown';
}

function detectBrowser(ua: string): string {
  if (/edg\//i.test(ua)) return 'Edge';
  if (/chrome\//i.test(ua) && !/edg\//i.test(ua)) return 'Chrome';
  if (/firefox\//i.test(ua)) return 'Firefox';
  if (/safari\//i.test(ua) && !/chrome\//i.test(ua)) return 'Safari';
  return 'Other';
}
